module.exports = __webpack_public_path__ + "img/small-invest.ac53734e.svg";